import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsInterestProps } from "./types";
import { messages } from "./messages";
import { useGetInterestPayment } from "hooks/interest/useGetInterestPayment";
import { useFormatter } from "hooks/utils/useFormatter";

export const HistoryDetailsInterest: React.FC<HistoryDetailsInterestProps> = ({
  data: interest,
}) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();
  const { data } = useGetInterestPayment(interest?.tid);
  const getStatus = () => {
    const stClass = "text-[--color-success]";
    const st = formatMessage(messages.approved);
    return <span className={stClass}>{st}</span>;
  };
  return (
    <div className="flex flex-col gap-y-6">
      <DetailsField
        label={formatMessage(messages.earned)}
        value={
          formatValue(interest.amount, 10) +
          " " +
          interest.ticker_id.toUpperCase()
        }
      />
      <DetailsField
        label={formatMessage(messages.fee)}
        value={formatValue(data?.fee ?? "", 10)}
      />
      {data && (
        <DetailsField
          label={formatMessage(messages.status)}
          value={getStatus()}
        />
      )}
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={interest.tid ?? ""}
        copy
      />
    </div>
  );
};
